// Central bilingual content for TANSEEQ Tax Consultations

export const BRAND = {
  name: { en: "TANSEEQ Tax Consultations", ar: "تنسيق للاستشارات الضريبية" },
  short: { en: "TANSEEQ", ar: "تنسيق" },
  ftaNo: "30003883",
  agency: { en: "Accredited Tax Agency", ar: "وكالة ضريبية معتمدة" },
  phone: "+971 56 115 2030",
  phoneRaw: "971561152030",
  email: "taxagent@tan-seeq.co",
  website: "www.tan-seeq.co",
  address: {
    en: "Bu Danig Area, Al Mirage Building, Office 210, Sharjah, UAE",
    ar: "منطقة بو دانق، مبنى الميراج، مكتب 210، الشارقة، الإمارات",
  },
  hours: { en: "Sun – Fri · 9:00 AM to 6:00 PM", ar: "الأحد – الجمعة · 9 صباحاً حتى 6 مساءً" },
};

export const NAV = [
  { key: "home", label: { en: "Home", ar: "الرئيسية" }, to: "/" },
  { key: "services", label: { en: "Services", ar: "الخدمات" }, to: "/services" },
  { key: "updates", label: { en: "Tax Updates", ar: "التحديثات الضريبية" }, to: "/tax-updates" },
  { key: "packages", label: { en: "Packages", ar: "الباقات" }, to: "/#packages" },
  { key: "software", label: { en: "Accounting Software", ar: "برنامج الحسابات" }, href: "https://sav-sys.com/?view=app", external: true },
  { key: "about", label: { en: "About", ar: "من نحن" }, to: "/#about" },
  { key: "contact", label: { en: "Contact", ar: "تواصل معنا" }, to: "/#contact" },
];

export const SOCIAL = {
  facebook: "https://www.facebook.com/p/Smart-Account-Vision-61552738853815/",
  linkedin: "https://ae.linkedin.com/in/smart-account-vision-421695297",
  instagram: "https://www.instagram.com/smart_account_vision/",
  system: "https://www.sa-v.co",
  software: "https://www.sav-sys.com",
};

export const HERO = {
  eyebrow: { en: "UAE Tax • Accounting • Compliance", ar: "ضرائب الإمارات • محاسبة • امتثال" },
  title: {
    en: "Clarity for your tax. Control for your books.",
    ar: "وضوح في الضرائب، ودقّة في الحسابات",
  },
  titleAccent: { en: "Confidence for your business.", ar: "وثقة أكبر في أعمالك" },
  titleLines: {
    en: ["Clarity for your tax.", "Control for your books.", "Confidence for your business."],
    ar: ["وضوحٌ في ضرائبك،", "ودقّةٌ في حساباتك،", "وثقةٌ أكبر في أعمالك."],
  },
  lead: {
    en: "TANSEEQ supports UAE businesses with practical tax advisory, VAT and Corporate Tax compliance, bookkeeping, financial reporting and FTA-related support — built around accurate records and clear next steps.",
    ar: "تدعم تنسيق الأعمال في دولة الإمارات بخدمات الاستشارات الضريبية وضريبة القيمة المضافة وضريبة الشركات ومسك الدفاتر والتقارير المالية ودعم التعامل مع الهيئة الاتحادية للضرائب، بالاعتماد على سجلات دقيقة وخطوات واضحة.",
  },
  ctaPrimary: { en: "Request a consultation", ar: "اطلب استشارة" },
  ctaSecondary: { en: "See 2026 tax updates", ar: "تحديثات 2026 الضريبية" },
};

export const STATS = [
  {
    value: "5%",
    label: { en: "Standard UAE VAT rate", ar: "النسبة الأساسية لضريبة القيمة المضافة" },
  },
  {
    value: "AED 3M",
    label: { en: "Small Business Relief revenue threshold", ar: "حد الإيرادات لتسهيلات الأعمال الصغيرة" },
  },
  {
    value: "2029",
    label: { en: "Small Business Relief extended to", ar: "تمديد تسهيلات الأعمال الصغيرة حتى" },
  },
  {
    value: "9%",
    label: { en: "Corporate Tax above AED 375,000", ar: "ضريبة الشركات لما يزيد عن 375٬000 درهم" },
  },
];

export const CORE_SERVICES = [
  {
    id: "vat",
    tag: "VAT",
    title: { en: "VAT Services", ar: "ضريبة القيمة المضافة" },
    desc: {
      en: "Registration, deregistration, return preparation and review, refund support and ongoing VAT compliance.",
      ar: "التسجيل وإلغاء التسجيل وإعداد ومراجعة الإقرارات ودعم الاسترداد والمتابعة المستمرة للامتثال.",
    },
  },
  {
    id: "ct",
    tag: "CT",
    title: { en: "Corporate Tax", ar: "ضريبة الشركات" },
    desc: {
      en: "Registration, compliance review, tax return support, Small Business Relief assessment and tax position review.",
      ar: "التسجيل ومراجعة الامتثال ودعم الإقرار وتقييم تسهيلات الأعمال الصغيرة ومراجعة الموقف الضريبي.",
    },
  },
  {
    id: "accounting",
    tag: "BK",
    title: { en: "Accounting & Bookkeeping", ar: "المحاسبة ومسك الدفاتر" },
    desc: {
      en: "Day-to-day books, ledgers, reconciliations, backlog accounting, schedules and management-ready records.",
      ar: "مسك الدفاتر والقيود والتسويات وتحديث الحسابات المتأخرة وتجهيز السجلات والتقارير للإدارة.",
    },
  },
  {
    id: "fta",
    tag: "FTA",
    title: { en: "FTA Support & Procedures", ar: "دعم الهيئة والإجراءات" },
    desc: {
      en: "Document preparation, reconciliations, notices, queries, reconsideration support and penalty review.",
      ar: "تجهيز المستندات والتسويات والردود والاستفسارات ودعم إعادة النظر ومراجعة الغرامات.",
    },
  },
  {
    id: "reporting",
    tag: "FS",
    title: { en: "Financial Reporting", ar: "التقارير المالية" },
    desc: {
      en: "Structured financial statements, management reporting and schedules built from organized records.",
      ar: "إعداد القوائم المالية والتقارير الإدارية والجداول المساندة بناءً على سجلات منظمة.",
    },
  },
  {
    id: "einvoice",
    tag: "E-I",
    title: { en: "eInvoicing Readiness", ar: "الفوترة الإلكترونية" },
    desc: {
      en: "Readiness review for the UAE eInvoicing rollout: data quality, system mapping and implementation planning.",
      ar: "مراجعة جاهزية الأعمال للفوترة الإلكترونية وجودة البيانات وربط الأنظمة وخطة الاستعداد للتطبيق.",
    },
  },
];

export const APPROACH = [
  {
    n: "01",
    title: { en: "Understand", ar: "نفهم" },
    desc: { en: "Business model, records, tax status and the exact issue.", ar: "طبيعة النشاط والسجلات والموقف الضريبي والمشكلة بدقة." },
  },
  {
    n: "02",
    title: { en: "Reconcile", ar: "نطابق" },
    desc: { en: "Bring records, ledgers and source documents into agreement.", ar: "مطابقة السجلات والدفاتر والمستندات المصدرية." },
  },
  {
    n: "03",
    title: { en: "Prepare", ar: "نجهّز" },
    desc: { en: "Returns, schedules, evidence and responses prepared coherently.", ar: "تجهيز الإقرارات والجداول والمستندات والردود بصورة مترابطة." },
  },
  {
    n: "04",
    title: { en: "Follow through", ar: "نتابع" },
    desc: { en: "Support continues through submission, queries and next deadlines.", ar: "المتابعة حتى التقديم والاستفسارات والمواعيد التالية." },
  },
];

export const TAX_UPDATES = [
  {
    id: "sbr",
    tag: "NEW",
    date: { d: "07", m: { en: "AUG", ar: "أغسطس" }, y: "2026" },
    title: {
      en: "Small Business Relief extended to 31 December 2029",
      ar: "تمديد تسهيلات الأعمال الصغيرة حتى 31 ديسمبر 2029",
    },
    body: {
      en: "Ministerial Decision No. 131 of 2026 extends the availability of Small Business Relief for eligible tax periods. The AED 3 million revenue threshold continues, subject to the legislative conditions.",
      ar: "مدّد القرار الوزاري رقم 131 لسنة 2026 إمكانية الاستفادة من تسهيلات الأعمال الصغيرة للفترات الضريبية المؤهلة، مع استمرار حد الإيرادات البالغ 3 ملايين درهم وفقاً للشروط التشريعية.",
    },
    fact: {
      en: "Eligible periods ending on or before 31 Dec 2029.",
      ar: "للفترات المؤهلة المنتهية في أو قبل 31 ديسمبر 2029.",
    },
    source: {
      label: { en: "UAE Ministry of Finance — MD No. 131 of 2026", ar: "وزارة المالية — القرار الوزاري 131 لسنة 2026" },
      url: "https://mof.gov.ae/en/news/ministry-of-finance-announces-extension-of-small-business-relief-for-corporate-tax-purposes-until-31-december-2029/",
    },
  },
  {
    id: "penalties",
    tag: null,
    date: { d: "14", m: { en: "APR", ar: "أبريل" }, y: "2026" },
    title: {
      en: "Administrative tax penalties amended",
      ar: "تعديل الغرامات الإدارية الضريبية",
    },
    body: {
      en: "Cabinet Decision No. 129 of 2025 entered into force on 14 April 2026 and amended a number of administrative penalties under UAE tax legislation, including reductions in selected compliance penalties.",
      ar: "دخل قرار مجلس الوزراء رقم 129 لسنة 2025 حيّز التنفيذ في 14 أبريل 2026، وعدّل عدداً من الغرامات الإدارية المرتبطة بالتشريعات الضريبية، بما في ذلك تخفيض بعض غرامات الامتثال.",
    },
    fact: {
      en: "Example: Arabic records-on-request penalty reduced from AED 20,000 to AED 5,000.",
      ar: "مثال: خفض غرامة عدم تقديم السجلات المطلوبة بالعربية من 20٬000 إلى 5٬000 درهم.",
    },
    source: {
      label: { en: "Federal Tax Authority — penalty amendment", ar: "الهيئة الاتحادية للضرائب — تعديل الغرامات" },
      url: "https://tax.gov.ae/en/media.centre/news/federal.tax.authority.announces.entry.into.force.of.the.decision.amending.administrative.penalties.imposed.for.violations.of.tax.legislation.and.calls.on.registrants.to.benefit.from.the.advantages.of.the.new.decision.aspx",
    },
  },
  {
    id: "waiver",
    tag: null,
    date: { d: "FTA", m: { en: "INITIATIVE", ar: "مبادرة" }, y: "" },
    title: {
      en: "Corporate Tax late-registration penalty waiver",
      ar: "الإعفاء من غرامة التأخر في تسجيل ضريبة الشركات",
    },
    body: {
      en: "The FTA initiative can waive the AED 10,000 late-registration penalty when the first Corporate Tax return — or annual declaration for applicable exempt persons — is filed within 7 months from the end of the first tax period or financial year, subject to the initiative rules.",
      ar: "يمكن للمبادرة إعفاء غرامة التأخر في التسجيل البالغة 10٬000 درهم عند تقديم أول إقرار ضريبة شركات — أو الإقرار السنوي للفئات المعفاة المعنية — خلال 7 أشهر من نهاية الفترة الضريبية أو السنة المالية الأولى، وفقاً لشروط المبادرة.",
    },
    fact: {
      en: "Paid penalties meeting the conditions are credited back to the tax account.",
      ar: "الغرامات المسددة المستوفية للشروط تُعاد كرصيد في الحساب الضريبي.",
    },
    source: {
      label: { en: "Federal Tax Authority — Waiver of Penalties", ar: "الهيئة الاتحادية للضرائب — الإعفاء من الغرامات" },
      url: "https://tax.gov.ae/en/about.fta/waiver.of.penalties.aspx",
    },
  },
  {
    id: "einvoicing",
    tag: null,
    date: { d: "01", m: { en: "JUL", ar: "يوليو" }, y: "2026" },
    title: {
      en: "UAE eInvoicing rollout is underway",
      ar: "بدء مراحل تطبيق الفوترة الإلكترونية",
    },
    body: {
      en: "Pilot and voluntary implementation began on 1 July 2026. For businesses with annual revenue of at least AED 50 million, the Accredited Service Provider appointment deadline was extended to 30 October 2026, while mandatory implementation remains 1 January 2027.",
      ar: "بدأت المرحلة التجريبية والتطبيق الاختياري في 1 يوليو 2026. وبالنسبة للأعمال التي تبلغ إيراداتها 50 مليون درهم فأكثر، مُدّد موعد تعيين مزوّد الخدمة المعتمد إلى 30 أكتوبر 2026، مع بقاء التطبيق الإلزامي في 1 يناير 2027.",
    },
    fact: {
      en: "Revenue < AED 50m: appoint ASP by 31 Mar 2027; implement by 1 Jul 2027.",
      ar: "إيرادات أقل من 50 مليون درهم: تعيين مزوّد الخدمة بحد أقصى 31 مارس 2027 والتطبيق في 1 يوليو 2027.",
    },
    source: {
      label: { en: "UAE Ministry of Finance — eInvoicing", ar: "وزارة المالية — الفوترة الإلكترونية" },
      url: "https://mof.gov.ae/en/about-us/initiatives/einvoicing/",
    },
  },
  {
    id: "vatdir",
    tag: null,
    date: { d: "JUL", m: { en: "2026", ar: "2026" }, y: "" },
    title: {
      en: "New VAT transaction directives published",
      ar: "توجيهات معاملات جديدة لضريبة القيمة المضافة",
    },
    body: {
      en: "The FTA VAT legislation page lists new 2026 transaction directives covering deemed supplies of services, life-insurance fees, conversion of digital-currency values into AED, tax-group exit adjustments and judicial expert services.",
      ar: "تسرد صفحة تشريعات ضريبة القيمة المضافة لدى الهيئة توجيهات معاملات جديدة لعام 2026 تشمل التوريدات الاعتبارية للخدمات ورسوم التأمين على الحياة وتحويل قيم العملات الرقمية إلى الدرهم وتعديلات الخروج من المجموعة الضريبية وخدمات الخبراء القضائيين.",
    },
    fact: null,
    source: {
      label: { en: "Federal Tax Authority — VAT Legislation", ar: "الهيئة الاتحادية للضرائب — تشريعات ض.ق.م" },
      url: "https://tax.gov.ae/en/legislation/vat.aspx",
    },
  },
];

export const SERVICE_DETAILS = [
  {
    id: "accounting",
    n: "01",
    title: { en: "Accounting & Bookkeeping", ar: "المحاسبة ومسك الدفاتر" },
    intro: {
      en: "Reliable tax compliance begins with reliable books. We organize source documents, post and review transactions, reconcile accounts and maintain schedules that support management and tax filings.",
      ar: "الامتثال الضريبي السليم يبدأ بدفاتر سليمة. ننظّم المستندات ونسجّل ونراجع العمليات ونطابق الحسابات ونجهّز الجداول التي تدعم الإدارة والإقرارات الضريبية.",
    },
    points: {
      en: ["Monthly/quarterly bookkeeping and ledger maintenance", "Bank, cash, customer and supplier reconciliations", "Backlog accounting and clean-up of prior periods", "Supporting schedules for VAT and Corporate Tax"],
      ar: ["مسك الدفاتر الشهري/الربع سنوي وصيانة الأستاذ العام", "تسويات البنوك والنقد والعملاء والموردين", "معالجة الحسابات المتأخرة وتنظيف الفترات السابقة", "جداول مساندة لضريبة القيمة المضافة وضريبة الشركات"],
    },
  },
  {
    id: "vat",
    n: "02",
    title: { en: "VAT Services", ar: "خدمات ضريبة القيمة المضافة" },
    intro: {
      en: "VAT work is handled from the underlying transactions upward — not just by entering totals into a return. We review taxable supplies, zero-rated/exempt treatment, input tax support, adjustments and evidence.",
      ar: "نتعامل مع ضريبة القيمة المضافة بدءاً من العمليات والمستندات، وليس بمجرد إدخال إجماليات في الإقرار؛ حيث نراجع التوريدات الخاضعة والمعفاة وصفرية النسبة وضريبة المدخلات والتعديلات والأدلة.",
    },
    points: {
      en: ["VAT registration and deregistration", "VAT return preparation, review and reconciliation", "VAT refund support and supporting-data preparation", "Voluntary disclosure and correction support", "Tax invoice and record-keeping compliance review"],
      ar: ["التسجيل وإلغاء التسجيل في ضريبة القيمة المضافة", "إعداد ومراجعة وتسوية إقرارات ض.ق.م", "دعم استرداد الضريبة وتجهيز البيانات المساندة", "دعم الإفصاح الطوعي والتصحيح", "مراجعة الامتثال للفواتير الضريبية وحفظ السجلات"],
    },
  },
  {
    id: "ct",
    n: "03",
    title: { en: "Corporate Tax Services", ar: "خدمات ضريبة الشركات" },
    intro: {
      en: "Support from registration and accounting readiness through return preparation and compliance review, including assessment of relevant reliefs and elections when applicable.",
      ar: "دعم من التسجيل وتجهيز الحسابات وحتى إعداد الإقرار ومراجعة الامتثال، بما في ذلك تقييم التسهيلات والاختيارات ذات الصلة عند انطباقها.",
    },
    points: {
      en: ["Corporate Tax registration and status review", "Tax return preparation support and reconciliations", "Small Business Relief eligibility assessment", "Related-party and transfer-pricing documentation support", "Tax position review for transactions and business changes"],
      ar: ["التسجيل في ضريبة الشركات ومراجعة الحالة", "دعم إعداد الإقرار والتسويات", "تقييم الأهلية لتسهيلات الأعمال الصغيرة", "دعم توثيق الأطراف ذات العلاقة وأسعار التحويل", "مراجعة الموقف الضريبي للمعاملات وتغييرات النشاط"],
    },
  },
  {
    id: "fta",
    n: "04",
    title: { en: "FTA Support & Tax Procedures", ar: "دعم الهيئة والإجراءات الضريبية" },
    intro: {
      en: "When the FTA requests information or a tax issue needs correction, the quality of the evidence and reconciliation matters. TANSEEQ helps organize the file and the response path.",
      ar: "عندما تطلب الهيئة معلومات أو يحتاج الموقف الضريبي إلى تصحيح، فإن جودة المستندات والتسويات تكون أساسية، وتساعد تنسيق في تنظيم الملف ومسار الرد.",
    },
    points: {
      en: ["FTA query and information-request preparation", "Tax audit document organization and reconciliation", "Penalty review and available relief/waiver assessment", "Reconsideration support and supporting records", "Tax registration data update and compliance cleanup"],
      ar: ["تجهيز الردود على استفسارات وطلبات معلومات الهيئة", "تنظيم مستندات التدقيق الضريبي والتسويات", "مراجعة الغرامات وتقييم مسارات الإعفاء المتاحة", "دعم إعادة النظر والسجلات المساندة", "تحديث بيانات التسجيل الضريبي ومعالجة الامتثال"],
    },
  },
  {
    id: "reporting",
    n: "05",
    title: { en: "Financial Statements & Reporting", ar: "القوائم والتقارير المالية" },
    intro: {
      en: "We prepare structured reports from the accounting records so owners and management can see revenue, costs, assets, liabilities, cash movement and financial position more clearly.",
      ar: "نجهّز تقارير منظمة من السجلات المحاسبية حتى تتمكن الإدارة والملاك من رؤية الإيرادات والتكاليف والأصول والالتزامات وحركة النقد والمركز المالي بوضوح.",
    },
    points: {
      en: ["Income statement / profit and loss", "Balance sheet / statement of financial position", "Cash flow support and management schedules", "Customer, supplier and account statements"],
      ar: ["قائمة الدخل / الأرباح والخسائر", "الميزانية العمومية / قائمة المركز المالي", "دعم التدفقات النقدية والجداول الإدارية", "كشوف العملاء والموردين والحسابات"],
    },
  },
  {
    id: "payroll",
    n: "06",
    title: { en: "Payroll Support", ar: "دعم الرواتب" },
    intro: {
      en: "Payroll support can be integrated with bookkeeping so payroll costs, liabilities and payments are reflected correctly in the accounts.",
      ar: "يمكن دمج دعم الرواتب مع المحاسبة حتى تظهر تكاليف الرواتب والالتزامات والمدفوعات بشكل صحيح في الحسابات.",
    },
    points: {
      en: ["Payroll schedules and accounting entries", "Salary accrual and payment reconciliation", "Management reporting support"],
      ar: ["جداول الرواتب والقيود المحاسبية", "استحقاق الرواتب وتسوية المدفوعات", "دعم التقارير الإدارية"],
    },
  },
  {
    id: "systems",
    n: "07",
    title: { en: "Accounting Systems & Process Setup", ar: "أنظمة المحاسبة وإعداد الإجراءات" },
    intro: {
      en: "We help businesses move from scattered spreadsheets or manual records toward controlled accounting processes with stronger audit trails and reporting.",
      ar: "نساعد الأعمال على الانتقال من الملفات المتفرقة أو السجلات اليدوية إلى إجراءات محاسبية أكثر تحكماً مع أثر مراجعة وتقارير أفضل.",
    },
    points: {
      en: ["Chart of accounts and opening setup", "Document workflow and approval controls", "VAT/Corporate Tax data mapping", "Accounting-system review and migration support"],
      ar: ["شجرة الحسابات والإعداد الافتتاحي", "سير العمل المستندي وضوابط الاعتماد", "ربط بيانات ض.ق.م وضريبة الشركات", "مراجعة أنظمة المحاسبة ودعم الترحيل"],
    },
  },
  {
    id: "einvoice",
    n: "08",
    title: { en: "UAE eInvoicing Readiness", ar: "الاستعداد للفوترة الإلكترونية" },
    intro: {
      en: "The UAE eInvoicing programme is being introduced in phases. We help assess invoice data, customer/supplier master data, tax coding and system readiness before mandatory implementation.",
      ar: "يُطبّق نظام الفوترة الإلكترونية في الإمارات على مراحل. نساعد في تقييم بيانات الفواتير وبيانات العملاء والموردين والترميز الضريبي وجاهزية النظام قبل التطبيق الإلزامي.",
    },
    points: {
      en: ["Readiness assessment and gap list", "Invoice and master-data cleanup", "Process mapping for ASP onboarding", "Accounting/ERP data readiness"],
      ar: ["تقييم الجاهزية وقائمة الفجوات", "تنظيف بيانات الفواتير والبيانات الرئيسية", "رسم العمليات لربط مزود الخدمة المعتمد", "جاهزية بيانات المحاسبة/تخطيط الموارد"],
    },
    note: {
      en: "TANSEEQ is not presented as an Accredited eInvoicing Service Provider (ASP). This service is business readiness and compliance support.",
      ar: "لا تُقدَّم تنسيق كمزوّد خدمة فوترة إلكترونية معتمد (ASP). الخدمة المذكورة هي دعم الجاهزية والامتثال للأعمال.",
    },
  },
];

export const IMAGES = {
  heroOffice:
    "https://static.prod-images.emergentagent.com/jobs/9ac005ce-d107-483a-8f31-2f6857f93772/images/44717e55ce6ba1431e4c880d46c0be9d26f9396f687744af4a764ed27ca0ced3.jpeg",
  brandTexture:
    "https://static.prod-images.emergentagent.com/jobs/9ac005ce-d107-483a-8f31-2f6857f93772/images/c18d666a8fb2a88d565f368e0454d30f45f73477410fa2268d6aedf30adeff40.jpeg",
  skyline:
    "https://images.pexels.com/photos/5097157/pexels-photo-5097157.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  advisor:
    "https://images.unsplash.com/photo-1758691737605-69a0e78bd193?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  desk:
    "https://images.pexels.com/photos/7172825/pexels-photo-7172825.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};
